import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4400Model } from '../kymw4400.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type OutputPageInfoCsvResponse = { FileName: string };

/**
 * ページ情報CSV出力サービス
 * @export OutputPageInfoCsvService
 * @class OutputPageInfoCsvService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class OutputPageInfoCsvService extends PlessJsonResponderSub<OutputPageInfoCsvResponse> {
  model: KYMW4400Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputPageInfoCsvService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.searchedOrderCode,
        MediumType: this.model.searchedMediumType,
        CoopCode: this.model.searchedCoopCode,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof OutputPageInfoCsvService
   */
  execute(model: KYMW4400Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('outputPageInfoCsv', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputPageInfoCsvService
   */
  success(data: OutputPageInfoCsvResponse) {
    this.model.csvPath = data.FileName;
    if (this.calbak) this.calbak();
  }
}
